/**
 * Side effect: tell the host this folder is the boat-collision module.
 * `load.ts` is the only file that imports this, and only through a glob,
 * so deleting the folder does not leave a broken import behind.
 */
import { registerBoatCollision } from '../host.ts';
import { resolveFleetTurn } from './fleetTurn.ts';
import { BOAT_NUDGE_CLOSING_PX } from './constants.ts';
import { formatBoatContactLog } from './log.ts';

registerBoatCollision({
  separate(map, seats, crashHarshness, turnTax) {
    const result = resolveFleetTurn(map, seats, crashHarshness, turnTax);

    return { runs: result.runs, hits: result.contacts };
  },
  formatHit: formatBoatContactLog,
  nudgeClosingPx: BOAT_NUDGE_CLOSING_PX,
});
